import React, { useState } from 'react';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { TextField } from '../components/ui/Field';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { useCopy } from '../contexts/LanguageContext';
import type { PersonalizationProfile } from '../types/profile';
interface AccessScreenProps {
  profile: PersonalizationProfile;
  update: (patch: Partial<PersonalizationProfile>) => void;
  onSubmit: () => void;
}
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function AccessScreen({
  profile,
  update,
  onSubmit
}: AccessScreenProps) {
  const copy = useCopy();
  const [error, setError] = useState('');
  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!profile.parent_name.trim()) {
      setError(copy.access.errorName);
      return;
    }
    if (!EMAIL_PATTERN.test(profile.purchase_email.trim())) {
      setError(copy.access.errorEmail);
      return;
    }
    setError('');
    onSubmit();
  }
  return <ScreenShell center data-id="element-46" data-mp="2750a0gn2n4cd">
      <div className="mb-8 text-center" data-id="element-47" data-mp="274i1akj82xnk">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold-200 bg-gold-200/40 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-gold-500" data-id="element-48" data-mp="2bwjcs48kgkcj">
          {copy.badge}
        </span>
        <div className="mt-6" data-id="element-49" data-mp="233oig5kn091j">
          <Headline data-id="element-50" data-mp="234zn07lwpktp">{copy.access.headline}</Headline>
          <Subtext data-id="element-51" data-mp="2qtisyghhhlim">{copy.access.subtext}</Subtext>
        </div>
      </div>

      <form onSubmit={handleSubmit} noValidate className="space-y-4" data-id="element-52" data-mp="2qs7lo6otxvmr">
        <TextField id="parent-name" label={copy.access.nameLabel} value={profile.parent_name} onChange={value => update({
        parent_name: value
      })} placeholder={copy.access.namePlaceholder} autoComplete="given-name" data-id="element-53" data-mp="2uuulatrqskui" />
        <TextField id="purchase-email" label={copy.access.emailLabel} type="email" inputMode="email" autoComplete="email" value={profile.purchase_email} onChange={value => update({
        purchase_email: value
      })} placeholder={copy.access.emailPlaceholder} data-id="element-54" data-mp="15fxxz66la7nx" />

        {error && <p role="alert" className="rounded-2xl bg-red-50 px-4 py-3 text-sm text-red-600" data-id="element-55" data-mp="hkuh2dzvmokv">
            {error}
          </p>}

        <div className="pt-2" data-id="element-56" data-mp="clhsnotcx9g6">
          <PrimaryButton type="submit" data-id="element-57" data-mp="ckgjjpvwix13">{copy.access.submit}</PrimaryButton>
        </div>
      </form>

      <p className="mt-4 text-center text-sm text-ink-muted" data-id="element-58" data-mp="7ktw6nmd00ek">{copy.access.footnote}</p>
    </ScreenShell>;
}